<div style="text-align:center;" *ngIf="standardBasedGrades.length == 0 && isBusy == false" translate>
    No Standard-Based Grades exist for this student.</div>
<div *ngIf="studentEnrollment!= null">
    <div *ngFor="let grades of standardBasedGrades">
        <div *ngIf="standardBasedGrades.length > 1 && grades.SchoolName != studentEnrollment.SchoolName"
            style="padding-top:20px;">
            <b style="font-size: 12pt;padding-bottom:5px; margin-top:20px;">{{grades.SchoolName}}</b>
        </div>

        <mat-table #table multiTemplateDataRows [dataSource]="grades.AngularMatData" tabindex="0"
            aria-label="Student Schedule Standard Data Table">
            <ng-container matColumnDef="More">
                <mat-header-cell *matHeaderCellDef style="min-width:68px;max-width:68px;text-align:center;"
                    class="print-ignore"><span translate>More</span></mat-header-cell>
                <mat-cell *matCellDef="let ss" style="min-width:68px;max-width:68px;text-align:center;"
                    class="print-ignore">
                    <span aria-label="Expand row for more details">
                        <i [ngClass]="checkExpanded(ss) ? 'detail-row-expanded-icon' : 'detail-row-collapsed-icon'" class="material-icons"
                            aria-hidden="true"></i>
                    </span>
                </mat-cell>
            </ng-container>
            <ng-container matColumnDef="Meets">
                <mat-header-cell *matHeaderCellDef style="width: 120px;"><span translate>Meets</span></mat-header-cell>
                <mat-cell *matCellDef="let ss" style="width: 120px;">{{ss.Meets}}</mat-cell>
            </ng-container>
            <ng-container matColumnDef="Term">
                <mat-header-cell *matHeaderCellDef style="width: 130px;"><span translate>Term</span></mat-header-cell>
                <mat-cell *matCellDef="let ss" style="width: 130px;">{{ss.Term}}</mat-cell>
            </ng-container>
            <ng-container matColumnDef="SubjectCode">
                <mat-header-cell *matHeaderCellDef style="width: 200px;"><span translate>Course-Section</span>
                </mat-header-cell>
                <mat-cell *matCellDef="let ss" style="width: 200px;">{{ss.SubjectCode}}-{{ss.Section}}</mat-cell>
            </ng-container>
            <ng-container matColumnDef="Course">
                <mat-header-cell *matHeaderCellDef style="width: 300px;"><span translate>Course Name</span>
                </mat-header-cell>
                <mat-cell *matCellDef="let ss" style="width: 300px;">{{ss.Course}}</mat-cell>
            </ng-container>
            <ng-container matColumnDef="Teacher">
                <mat-header-cell *matHeaderCellDef style="width: 300px;"><span translate>Teacher Name</span>
                </mat-header-cell>
                <mat-cell *matCellDef="let ss" style="width: 300px;">{{ss.Teacher}}</mat-cell>
            </ng-container>

            <ng-container matColumnDef="expandedDetail">
                <div mat-cell *matCellDef="let ss" style="width:100%;margin-left:40px;margin-right:10px;"
                    aria-label="Standard Grades Details">
                    <div class="mat-detail-card">
                        <table style="width:100%">
                            <tr>
                                <td>
                                    <a *ngIf="showAttendanceLink==true" style="padding-left:20px;cursor: pointer;"
                                        (click)="viewAttendance(ss)" translate>Attendance</a>
                                    <a *ngIf="showSendEmailLink==true" style="padding-left:20px; cursor: pointer;"
                                        (click)="sendEmail(ss)" translate>Email Teacher</a>
                                    <a *ngIf="enableClassInfoTeacherProfiles && ss.HasClassProfile" style="padding-left:20px; cursor: pointer;"
                                        (click)="viewCourseProfile(ss)" translate>Class Information</a>
                                    <a *ngIf="enableClassInfoTeacherProfiles && ss.HasTeacherProfile" style="padding-left:20px; cursor: pointer;"
                                        (click)="viewTeacherProfile(ss)" translate>Teacher Profile</a>
                                </td>
                            </tr>
                        </table>
                        <div>
                            <table class="mat-table" style="width:100%">
                                <thead>
                                    <tr class="mat-header-row">
                                        <th class="mat-header-cell"
                                            style="min-width:250px; color:rgba(23, 20, 20, 0.54);" translate>Standard
                                        </th>
                                        <th class="mat-header-cell" style="min-width:40px; text-align:center;"
                                            *ngFor="let term of ss.TempReportCardGradesTerms">
                                            <span style="padding:5px;" (click)="commentsAndBehaviorMarksClick(ss, term)"
                                                [ngClass]="{'gradesLink': showGradesLink(term) }">
                                                <span *ngIf="term.OverrideGradingTerm == null"
                                                    [ngStyle]="{'color': showGradesLink(term)  ? 'blue' : 'rgba(23, 20, 20, 0.54);', 'cursor': showGradesLink(term) ? 'pointer' : 'default;'}">
                                                    {{term.GradingTerm}}
                                                </span>
                                                <span *ngIf="term.OverrideGradingTerm != null"
                                                [ngStyle]="{'color': showGradesLink(term)  ? 'blue' : 'rgba(23, 20, 20, 0.54);', 'cursor': showGradesLink(term) ? 'pointer' : 'default;'}">
                                                {{term.OverrideGradingTerm}}
                                            </span>
                                            </span>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody tabindex="0"
                                    [attr.aria-label]="getAriaDetailRow(ss.ReportCardGradesStandards)">
                                    <tr *ngFor="let termGrades of ss.ReportCardGradesStandards"
                                        class="mat-row standardDetailRow">
                                        <td class="mat-cell" style="min-width:250px;">{{termGrades.Standard}}</td>
                                        <td class="mat-cell" style="min-width:40px;text-align:center;"
                                            *ngFor="let header of ss.TempReportCardGradesTerms">
                                            <div
                                                *ngFor="let grade of termGrades.ReportCardGradesTerms | standardsBasedGradesFilter:header">
                                                <span style="padding-left:5px;">{{grade.Grade}}</span>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </ng-container>

            <mat-header-row *matHeaderRowDef="columnsToDisplay"></mat-header-row>
            <mat-row *matRowDef="let row; columns: columnsToDisplay;" matRipple tabindex="0"
                (click)="toggleExpanded(row)" [attr.aria-label]="getAriaRow(row)"></mat-row>
            <mat-row *matRowDef="let row; columns: ['expandedDetail']"
                [@detailExpand]="checkExpanded(row) ? 'expanded' : 'collapsed'" style="overflow: hidden"></mat-row>
        </mat-table>
    </div>
</div>